import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { aGetFeaturesFlagRequest, aUpdateFeaturesFlagRequest } from '../../../reducers';
import { getFeaturesFlag } from '../../../selectors/featuresFlag';
import { checkPermisson } from '../../../selectors/common';
import { PERMISSIONS } from '../../../constants';

const mapToProps = (state) => ({
  featuresFlagProps: getFeaturesFlag(state),
  checkPermissonProps: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  getFeaturesFlagList: (payload) => dispatch(aGetFeaturesFlagRequest(payload)),
  updateFeaturesFlag: (payload) => dispatch(aUpdateFeaturesFlagRequest(payload)),
});

const FeaturesFlag = ({
  featuresFlagProps, checkPermissonProps, getFeaturesFlagList, updateFeaturesFlag,
}) => {
  const [featuresFlags, setFeaturesFlags] = useState([]);
  const [hasChanged, setHasChanged] = useState(false);
  const hasPermissionTo = {
    view: checkPermissonProps(PERMISSIONS.FEATURES_FLAG_VIEW),
    edit: checkPermissonProps(PERMISSIONS.FEATURES_FLAG_UPDATE),
  };
  useEffect(() => {
    getFeaturesFlagList();
  // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (!featuresFlags || featuresFlags.length === 0) setFeaturesFlags([...featuresFlagProps]);
  // eslint-disable-next-line
  }, [featuresFlagProps]);

  const toggleStatus = (index, status) => {
    const newFeatureFlagList = featuresFlags.map((flag) => ({ ...flag }));
    newFeatureFlagList[index].status = status === 0 ? 1 : 0;
    setFeaturesFlags(newFeatureFlagList);
    setHasChanged(true);
  };

  const revertChanges = () => {
    setFeaturesFlags([...featuresFlagProps]);
    setHasChanged(false);
  };

  const getFeatFlagChanged = (listOriginal, featFlags) => {
    const listFeatFlagChanged = [];
    listOriginal.forEach((orginal) => {
      const flagChanged = featFlags.find(
        (flag) => flag.name === orginal.name && flag.status !== orginal.status,
      );
      if (flagChanged) listFeatFlagChanged.push(flagChanged);
    });
    return listFeatFlagChanged;
  };

  const saveChanges = () => {
    const featureFlagsChanged = getFeatFlagChanged(
      featuresFlagProps,
      featuresFlags,
    );
    updateFeaturesFlag({ featureFlags: featureFlagsChanged });
    setHasChanged(false);
  };

  return (
    <div className="content__wrapper">
      <div className="table-responsive fix-odd">
        {hasPermissionTo.view && (
          <table className="table-style">
            <thead>
              <tr>
                <th>Feature Flag</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {featuresFlags?.map((featureFlag, index) => (
                <tr key={featureFlag.name} className="table-style__row">
                  <td>{featureFlag.name}</td>
                  <td>
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={featureFlag.status !== 0}
                        onChange={toggleStatus.bind(this, index, featureFlag.status)}
                      />
                      <span className="toggle-switch__slider" />
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="m-t-30 text-right d-flex justify-content-end">
        {hasChanged && (<div className="info-txt">You have unsaved changes !</div>)}
        {hasPermissionTo.edit && (
          <>
            <button className="btn btn-secondary m-l-10" type="button" disabled={!hasChanged} onClick={revertChanges}>Cancel</button>
            <button className="btn btn-primary m-l-10" type="button" disabled={!hasChanged} onClick={saveChanges}>Save</button>
          </>
        )}
      </div>
    </div>
  );
};

export default connect(mapToProps, actionsToProps)(FeaturesFlag);
